export const checkFeatureFlag = (flagName) => {
  if (typeof posthog === 'undefined') {
    return false;
  }

  return posthog.isFeatureEnabled(flagName);
};
